import {
  CITIES_DICTIONARY_QUERY,
  CITIZENSHIP_QUERY,
  COUNTIES_DICTIONARY_QUERY,
  COUNTRIES_DICTIONARY_QUERY,
  LEGAL_FORMS_QUERY
} from 'components/common/select/BrowserContainer/gql/queries';
import { ACTIVITY_FIELDS_QUERY } from '../queries/DictionaryQueries';
import { CATEGORY_SUBCATEGORY_USAGE_TYPE_AND_ACTIVITY_FIELD, USAGE_TYPE_AND_CATEGORY } from 'features/offer/edit/insurances/queries';
import {
  ACQUISITION_EXCHANGE_RATE_QUERY,
  CREDIT_FINANCING_LINE_QUERY,
  INTEREST_TYPE_QUERY,
  INVOICING_BANK_QUERY,
  INVOICING_EXCHANGE_RATES_QUERY,
  OFFER_TYPE_QUERY,
  SCHEDULE_TYPE_QUERY
} from 'features/offer/edit/financials/additionalData/queries';
import { GET_RISK_ANALYSIS_TYPES_QUERY } from 'features/folder/edit/generalData/info/queries';

const UNBOUND_VALUE_TYPE = 'UNBOUND_VALUE_TYPE';

// In case of a query having multiple definitions, the index variable represents the definition that we want to target specifically for when we reset the Apollo Cache
const getName = (query, index = 0) => query.definitions[0].selectionSet.selections[index].name.value;

const configurationKeys = {
  rootQueryEntries: [
    {
      query: getName(ACTIVITY_FIELDS_QUERY),
      type: 'ActivityField'
    },
    {
      query: getName(LEGAL_FORMS_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(CATEGORY_SUBCATEGORY_USAGE_TYPE_AND_ACTIVITY_FIELD, 0),
      type: 'AssetCategory'
    },
    {
      query: getName(CATEGORY_SUBCATEGORY_USAGE_TYPE_AND_ACTIVITY_FIELD, 1),
      type: 'AssetSubcategory'
    },
    {
      query: getName(USAGE_TYPE_AND_CATEGORY, 1),
      type: 'UsageType'
    },
    {
      query: getName(USAGE_TYPE_AND_CATEGORY, 2),
      type: 'SafetyPackages'
    },
    {
      query: getName(CITIES_DICTIONARY_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(COUNTIES_DICTIONARY_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(COUNTRIES_DICTIONARY_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(CITIZENSHIP_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(OFFER_TYPE_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(GET_RISK_ANALYSIS_TYPES_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(INVOICING_EXCHANGE_RATES_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(ACQUISITION_EXCHANGE_RATE_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(CREDIT_FINANCING_LINE_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(INVOICING_BANK_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(SCHEDULE_TYPE_QUERY),
      type: UNBOUND_VALUE_TYPE
    },
    {
      query: getName(INTEREST_TYPE_QUERY),
      type: UNBOUND_VALUE_TYPE
    }
  ],
  cacheEntries: ['ConventionInfo']
};

export { configurationKeys, UNBOUND_VALUE_TYPE };
